import { createSlice, createSelector } from '@reduxjs/toolkit';
import { normalize, schema } from 'normalizr';

const apptSchema = new schema.Entity('appointments');

export const normalizedApptsSelector = createSelector(
  (state) => state.home.appointments,
  (subState) => subState,
);

export const appointmentIdsSelector = createSelector(
  (state) => state.home.appointmentIds,
  (subState) => subState,
);

const homeSlice = createSlice({
  name: 'home',
  initialState: {
    appointments: {},
    appointmentIds: [],
  },
  reducers: {
    normalizeApptsByDate(state, action) {
      const { data } = action.payload;
      const normalizeAppts = normalize(data, [apptSchema]);
      state.appointments = normalizeAppts?.entities?.appointments;
      state.appointmentIds = normalizeAppts?.result;
    },
    patientCheckedInStatusHomeUpdate(state, action) {
      const { appointmentId, telemedStatus } = action.payload;
      state.appointments[appointmentId].telemedStatus = telemedStatus;
    },
  },
});

export const { normalizeApptsByDate, patientCheckedInStatusHomeUpdate } = homeSlice.actions;

export default homeSlice.reducer;
